import React from 'react';
import styled from '@emotion/styled';
import { routes, InternalLink } from 'gatsby-theme-apollo';
import EntityList from './entity-list';
import { ContentBox } from '../layout/content-box';

const Build = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  border-radius: ${props => props.theme.radius};
  margin-bottom: 10px;
  justify-content: center;
`;

const BuildHeader = styled.div`
  width: 100%;
  padding: 10px;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: ${props => props.theme.radius};
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
`;

const BuildAuthor = styled(InternalLink)({
  color: `rgba(255, 255, 255, 0.5)`
});

const Builds = ({ gameName, builds = [], limit = 3 }) => {
  return (
    <ContentBox>
      {builds &&
        gameName &&
        builds.length > 0 &&
        builds.slice(0, limit).map(build => {
          return (
            <Build>
              <BuildHeader>
                <h3>{build.name}</h3>
                {build.author && (
                  <BuildAuthor to={routes.User(build.author.name)}>
                    by {build.author.name}
                  </BuildAuthor>
                )}
              </BuildHeader>

              <EntityList
                gameName={gameName}
                entities={build.members}
                entityType={'gear'}
              />
            </Build>
          );
        })}
    </ContentBox>
  );
};

export default Builds;
